"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoaderContextProvider = exports.useLoader = void 0;
var _react = _interopRequireWildcard(require("react"));
var _router = _interopRequireDefault(require("next/router"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }
var __jsx = _react["default"].createElement;
var LoaderContext = /*#__PURE__*/_react["default"].createContext(false);
var LoaderContextProvider = function LoaderContextProvider(props) {
  var _useState = (0, _react.useState)(false),
    isLoading = _useState[0],
    setLoading = _useState[1];
  var _useState2 = (0, _react.useState)(false),
    submenuLoaded = _useState2[0],
    setSubmenuLoaded = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    cookieNoticeLoaded = _useState3[0],
    setCookieNoticeLoaded = _useState3[1];
  var _useState4 = (0, _react.useState)(props.externalContentTimeout),
    externalContentTimeout = _useState4[0],
    setExternalContentTimeout = _useState4[1];
  (0, _react.useEffect)(function () {
    var handlerComplete = function handlerComplete() {
      return setLoading(false);
    };
    var handlerStart = function handlerStart() {
      return setLoading(true);
    };
    _router["default"].events.on("routeChangeStart", handlerStart);
    _router["default"].events.on("routeChangeComplete", handlerComplete);
    return function () {
      _router["default"].events.off("routeChangeStart", handlerStart);
      _router["default"].events.off("routeChangeComplete", handlerComplete);
    };
  }, []);
  return __jsx(LoaderContext.Provider, {
    value: {
      isLoading: isLoading,
      externalContentTimeout: externalContentTimeout,
      setExternalContentTimeout: setExternalContentTimeout,
      submenuLoaded: submenuLoaded,
      setSubmenuLoaded: setSubmenuLoaded,
      cookieNoticeLoaded: cookieNoticeLoaded,
      setCookieNoticeLoaded: setCookieNoticeLoaded
    }
  }, props.children);
};
exports.LoaderContextProvider = LoaderContextProvider;
var useLoader = function useLoader() {
  return (0, _react.useContext)(LoaderContext);
};
exports.useLoader = useLoader;